import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE } from './kunde-konditionsliste.shared';
import { kundenKonditionslisteRoutes } from './kunden-konditionsliste.routes';

export function provideKundenKonditionslisteModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'kundenkonditionsliste',
        title: '#KUNDEN_KONDITIONSLISTE.APP',
        icon: 'fa-regular fa-list',
        route: '/kundenkonditionsliste',
        permission: SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE,
        group: getModuleGroupByName('Produktion'),
      },
      withSoftAppsModuleRoutes({ app: kundenKonditionslisteRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}

export const kundenKonditionslisteProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'kundenkonditionsliste',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#KUNDEN_KONDITIONSLISTE.APP',
      icon: 'fa-regular fa-list',
      route: '/kundenkonditionsliste',
      permission: SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE,
      group: getModuleGroupByName('Produktion'),
    });
  }),
];
